import { RestClient } from "clients/rest";
import { PageableResponse } from "../PageableResponse";

export type B000160FindRequest = Partial<{
  hachuYmdFrom: string;
  hachuYmdTo: string;
  nyukayoteiYmdFrom: string;
  nyukayoteiYmdTo: string;
  eigyoCdFrom: string;
  eigyoCdTo: string;
  bumonCdFrom: string;
  bumonCdTo: string;
  shainCdFrom: string;
  shainCdTo: string;
  hachudenpyoNoFrom: string;
  hachudenpyoNoTo: string;
  shireCd: string;
  sokoCd: string;
  shodaibun: string;
  shochubun: string;
  shoshobun: string;
  shohinCd: string;
  kanryoKbn: string;
  janCd: string;
  shohinshubetsuKbn: string;
  gamenId: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B000160FindResponse = {
  uchiwakeNmr: string;
  hachuYmd: string;
  nyukayoteiYmd: string;
  hachudenpyoNo: number;
  hachudenpyoNoF: number;
  shohinCd: string;
  shohinNm: string;
  hachusu: number;
  shiresu: number;
  hachuzansu: number;
  hachuKin: number;
  hachuZankin: number;
  sokoCd: string;
  sokoNm: string;
  shireNm: string;
  shainNm: string;
  bumonNmr: string;
  kanryoKbnView: string;
};

export const B000160Find = (props: B000160FindRequest) => {
  return RestClient.get<PageableResponse<B000160FindResponse[]>>(
    "b000160/find",
    {
      params: props,
    }
  );
};
